var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictogramQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.102 2.407H18.899c-2.602 0-4.712 2.11-4.712 4.712v44.762c0 2.602 2.11 4.712 4.712 4.712h21.203c2.602 0 4.712-2.109 4.712-4.712V7.119c0-2.602-2.11-4.712-4.712-4.712z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.813 11.831H14.187m30.626 35.338H14.187m9.423-40.05h11.78",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.601 18.898h-4.712v4.712h4.712v-4.712zm0 16.492h-4.712v4.712h4.712V35.39zm16.491-16.492H35.38v4.712h4.712v-4.712z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.889 30.678h9.424v2.356m4.711 0v7.068h7.068v-7.068h-2.356m-9.423 4.712v2.356m0-21.204v7.068h2.356m4.711 2.356h4.712",
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 52.47a.59.59 0 0 1-.589-.589.59.59 0 0 1 .589-.589m0 1.178a.59.59 0 0 0 .589-.589.59.59 0 0 0-.589-.589"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramQr);
export default __webpack_public_path__ + "static/media/pictogram-qr.53aaa40f7a0818ddcf1032940444443d.svg";
export { ForwardRef as ReactComponent };